import { axios } from '../../services/axios';

export default async function getDashboardCompanyServices(companyId) {
    return await axios
        .get(`/Dashboard/Company/${companyId}/Services`, {
            headers: {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
                Expires: '0',
            },
        })
        .then((response) => response)
        .catch((error) => error);
}
